import ChatViewState from '../store/schema/ChatViewState';
import { getStore } from '../store/ucmaStore';

export default function getChatBySessionId(sessionId: number): ChatViewState {
    return getStore().chats.filter(chat => chat.sessionId == sessionId)[0];
}
